import axios from '../../utils/axios';
import { objectToFormData } from '../utils';

// GET
// /Api/Contracts/Contracts
export async function getContracts() {
    const response = await axios.get(`Contracts/Contracts`);
    return response;
}

// GET
// /Api/Contracts/ContractOptions
export async function getContractOptions() {
    const response = await axios.get(`Contracts/ContractOptions`);
    return response;
}

// GET
// /Api/Contracts/Contract id
export async function getContract(id) {
    const response = await axios.get(`Contracts/Contract?id=${id}`);
    return response;
}

// POST
// /Api/Contracts/ContractForm
export async function contractForm(form) {
    const response = await axios.post('Contracts/ContractForm', objectToFormData(form));
    return response;
}

// GET/Api/Contracts/ContractFile;
export async function getContractFile(id, fileType) {
    const response = await axios.get(`/Contracts/ContractFile?id=${id}&fileType=${fileType}`, {
        responseType: 'blob',
    });
    return response;
}

// POST
// /Api/Contracts/DownloadContractFiles contractIds
export async function downloadContractFiles(contractIds) {
    const response = axios.post('Contracts/DownloadContractFiles', contractIds, { responseType: 'blob' });
    return response;
}

export async function updateContractFile(file, id, fileType) {
    const response = axios.post('Contracts/UpdateContractFile', objectToFormData({ file, id, fileType }));
    return response;
}

// POST
// /Api/Contracts/DeleteContracts ids
export async function deleteContracts(ids) {
    const response = await axios.post('Contracts/DeleteContracts', objectToFormData({ ids }));
    return response;
}

// POST
// /Api/Contracts/DeleteContract id
export async function deleteContract(id) {
    const response = await axios.post('Contracts/DeleteContract', objectToFormData({ id }));
    return response;
}

// POST
// /Api/Contracts/DeleteContractFile id fileType
export async function deleteContractFile(id, fileType) {
    const response = axios.post('Contracts/DeleteContractFile', objectToFormData({ id, fileType }));
    return response;
}

// GET
// /Contracts/GetContractsAIModels
export async function GetContractsAIModels() {
    const response = await axios.get('Contracts/GetContractsAIModels');
    return response.data;
}

// POST
// /Contracts/PostToContractsAI { query, model }
export async function PostToContractsAI(query, model, files) {
    const response = await axios.post('Contracts/PostToContractsAI', objectToFormData({ query, model, files }));
    return response.data;
}

// GET
// /Contracts/GetUserConversations?startDate=&endDate=
export async function GetUserConversations(startDate, endDate) {
    const response = await axios.get('Contracts/GetUserConversations', { params: { startDate, endDate } });
    return response.data;
}

// GET
// /Contracts/GetConversation?conversationId=
export async function GetConversation(conversationId) {
    const response = await axios.get('Contracts/GetConversation', { params: { conversationId } });
    return response.data;
}
